import { render, staticRenderFns } from "./EntryDairy.vue?vue&type=template&id=e53b5b52&scoped=true"
import script from "./EntryDairy.vue?vue&type=script&lang=js"
export * from "./EntryDairy.vue?vue&type=script&lang=js"
import style0 from "./EntryDairy.vue?vue&type=style&index=0&id=e53b5b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53b5b52",
  null
  
)

export default component.exports